<template>
  <base-content>
    <div class="tw-flex tw-flex-col tw-mb-4">
      <h1 class="tw-text-xl md:tw-text-2xl tw-font-thin tw-mb-4">Operations Summary</h1>
      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-3">
        <active-plans :business-id="businessId" />
        <active-prescriptions v-if="organization.usePrescriptionProgramSetting" :business-id="businessId" />
        <activities v-if="organization.useTodoSetting" :business-id="businessId" />
        <charges :business-id="businessId" />
      </div>
      <div class="tw-mt-6 tw-mb-4">
        <h1 class="tw-text-xl md:tw-text-2xl tw-font-thin tw-mb-4">Practice Summary</h1>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3">
          <plan-counts-by-group :business-id="businessId" />
          <prescription-counts-by-group v-if="organization.usePrescriptionProgramSetting" :business-id="businessId" />
          <activities-by-type v-if="organization.useTodoSetting" :business-id="businessId" />
        </div>
      </div>
      <div v-if="isAdministrator && !isLocationFiltered" class="tw-mt-6 tw-mb-4">
        <h1 class="tw-text-xl md:tw-text-2xl tw-font-thin tw-mb-4">Revenue Summary</h1>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3">
          <revenue-trend :business-id="businessId" />
          <monthly-revenue :business-id="businessId" />
        </div>
      </div>
    </div>
  </base-content>
</template>

<script>
import { mapGetters } from "vuex";
import ActivePlans from "@/views/business/dashboard/components/ActivePlans";
import ActivePrescriptions from "@/views/business/dashboard/components/ActivePrescriptions";
import Activities from "@/views/business/dashboard/components/Activities";
import ActivitiesByType from "@/views/business/dashboard/components/ActivitiesByType";
import Charges from "@/views/business/dashboard/components/Charges";
import PlanCountsByGroup from "@/views/business/dashboard/components/PlanCountsByGroup";
import PrescriptionCountsByGroup from "@/views/business/dashboard/components/PrescriptionCountsByGroup";
import RevenueTrend from "@/views/business/dashboard/components/RevenueTrend";
import MonthlyRevenue from "@/views/business/dashboard/components/MonthlyRevenue";

import { capitalize } from "lodash";

export default {
  name: "BusinessDashboardView",
  components: {
    ActivePlans,
    ActivePrescriptions,
    Activities,
    ActivitiesByType,
    Charges,
    PlanCountsByGroup,
    PrescriptionCountsByGroup,
    RevenueTrend,
    MonthlyRevenue,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("role", ["isBusinessAdministrator", "isPredictile", "isLocationFiltered"]),
    ...mapGetters("organization", ["organization"]),
    isAdministrator() {
      return this.isBusinessAdministrator(this.businessId) || this.isPredictile();
    },
  },
  methods: {
    capitalize,
  },
};
</script>
